import { find } from '../helpers';

const element = find('[data-video-id]')

if (element) {
    import('./index')
}
